import qs from "query-string";
import { responseType } from "../constants";
import { fetchSafe } from "./fetch.safe";
import { News } from "../types/news/News";
import { NewsQueryParams } from '../types/news/NewsQueryParams';

interface NewsListQueryParams extends NewsQueryParams {
    count?: number;
    offset?: number;
}

function getNews(params: NewsListQueryParams): Promise<News[]> {
    return fetchSafe(`${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/news`, {
        method: "POST",
        body: JSON.stringify(params),
    });
}

function getNewsTotalCount(params?: NewsListQueryParams): Promise<number> {
    const queryParams = qs.stringify(params || {});
    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/news/count?${queryParams}`
    );
}

function getNewsDetails(referenceName: string, params: NewsQueryParams = {}): Promise<News> {
    const queryString = qs.stringify(params);

    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/news/${referenceName}?${queryString}`
    );
}

function createOrUpdateNews(newsData: News) {
    return fetchSafe(`${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/news`, {
        method: "PUT",
        body: JSON.stringify(newsData),
    });
}

function deleteNews(referenceName: string) {
    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/news/${referenceName}`,
        {
            method: "DELETE",
            responseType: responseType.none,
        }
    );
}

function downloadDocument(newsReferenceName: string, documentReferenceName: string) {
    const requestOptions = {
        responseType: responseType.file,
    };

    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/news/${newsReferenceName}/documents/${documentReferenceName}/download`,
        requestOptions,
    );
}

function downloadDocuments(newsReferenceName: string) {
    const requestOptions = {
        responseType: responseType.file,
    };

    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/news/${newsReferenceName}/documents/download`,
        requestOptions,
    );
}

function downloadManagerMeetings(): Promise<{ blob: Blob, name: string }> {
    const requestOptions = {
        responseType: responseType.file,
    };

    return fetchSafe(
        `/api/profile/manager-meetings/download`,
        requestOptions,
    );
}

export const newsService = {
    getNews,
    getNewsTotalCount,
    getNewsDetails,
    createOrUpdateNews,
    deleteNews,
    downloadDocument,
    downloadDocuments,
    downloadManagerMeetings,
};
